import axios from '@/api/axiosInstance';

export default async function getStudentClasses() {
  const response = await axios({
    method: 'get',
    url: `${process.env.NEXT_PUBLIC_API}/student/classes`,
  });
  return response.data;
}
